import FullWidthImageSlider from "../../../../src/components/FullWidthImageSlider";
import Slide from "../../../../src/components/FullWidthImageSlider/Slide";
import ImageSmartNotesDates from "../../../../src/content/blog-posts/smart-notes/image2.png";
import * as React from 'react';
export default {
  FullWidthImageSlider,
  Slide,
  ImageSmartNotesDates,
  React
};